(ns hai.library.connections.invalid-reason
  "What to tell the user about a connection the platform marked invalid
  (`:connection/api-key-invalid?`), keyed by its
  `:connection/api-key-invalid-reason`. Lives in one place so the Connections
  page, the Home calendar banner and the Timeline integration card say the
  same thing, and only offer Reconnect where reconnecting can fix it.")

(def ^:private descriptions
  {;; The Google account has no Calendar, e.g. its Workspace admin turned it
   ;; off. Reconnecting only helps once Calendar is back on (it clears the
   ;; invalid flag; too early and the next sync flags it again).
   :not-a-calendar-user
   {:status      "No calendar on this account"
    :explanation (str "Google Calendar isn't turned on for this account. Once your "
                      "Google Workspace admin turns it on, reconnect. Or remove this "
                      "connection.")
    :reconnect?  true}

   :scope-insufficient
   {:status      "Missing permissions"
    :explanation "Humble can't read this calendar. Reconnect and allow calendar access."
    :reconnect?  true}

   :token-revoked
   {:status      "Access expired"
    :explanation (str "Humble's access to this account was removed or has expired. "
                      "Reconnect to keep syncing.")
    :reconnect?  true}})

(def ^:private unknown-description
  {:status      "Connection broken"
   :explanation "Humble can't access this account. Reconnect to fix."
   :reconnect?  true})

(defn describe
  "`{:status :explanation :reconnect?}` for an invalid connection's `reason`.
  `:status` is a short label for badges and cards, `:explanation` a sentence for
  tooltips and banners. A missing or unknown reason gets the generic
  \"Connection broken\" wording."
  [reason]
  (get descriptions reason unknown-description))
